/**
 * Sekcja "Kto dodawał" - tabela `dodali` z podsumowania
 * (login, ile dodal, srednie opoznienie w dniach od wystawienia).
 */
import React from 'react';

const th = { padding: '5px 8px', textAlign: 'left', borderBottom: '2px solid var(--border)', fontSize: '11px', fontWeight: 600, color: 'var(--text-secondary)', whiteSpace: 'nowrap' };
const td = { padding: '4px 8px', borderBottom: '1px solid var(--border)', fontSize: '11px' };

const kolorOpoznienia = (dni) => {
  if (dni === null || dni === undefined) return 'var(--text-muted)';
  if (dni <= 2) return 'var(--success)';
  if (dni > 7) return 'var(--danger)';
  return 'var(--warning)';
};

const KtoDodawal = ({ dodali }) => {
  const lista = Array.isArray(dodali) ? [...dodali].sort((a, b) => (b.dodane || 0) - (a.dodane || 0)) : [];
  return (
    <div className="card" data-testid="kto-dodawal" style={{ fontSize: '12px' }}>
      <h3 style={{ margin: '0 0 8px', fontSize: '13px', fontWeight: 600 }}>Kto dodawał</h3>
      {lista.length === 0 ? (
        <div style={{ color: 'var(--text-muted)', fontSize: '11px' }}>Brak danych w zakresie</div>
      ) : (
        <div style={{ overflow: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={th}>Login</th>
                <th style={{ ...th, textAlign: 'right' }}>Dodane</th>
                <th style={{ ...th, textAlign: 'right' }}>Śr. opóźnienie</th>
              </tr>
            </thead>
            <tbody>
              {lista.map(d => (
                <tr key={d.login}>
                  <td style={{ ...td, fontWeight: 600 }}>{d.login || '—'}</td>
                  <td style={{ ...td, textAlign: 'right' }}>{d.dodane ?? '—'}</td>
                  <td style={{ ...td, textAlign: 'right', color: kolorOpoznienia(d.srednie_opoznienie_dni), fontWeight: 600 }}>
                    {d.srednie_opoznienie_dni === null || d.srednie_opoznienie_dni === undefined ? '—' : `${Number(d.srednie_opoznienie_dni).toLocaleString('pl-PL', { maximumFractionDigits: 1 })} dn.`}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default KtoDodawal;
